import type { ResultProps } from 'antd';

import { StyledResult } from './styles';

export const Result = (props: ResultProps) => <StyledResult {...props} />;
